import { jsx as c } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const p = (o) => /* @__PURE__ */ c(m, { ...o, children: /* @__PURE__ */ c("path", { d: "M14.0973 5.38759 9.00392 10.481 6.2604 7.74941 5.00792 9.00189l3.996 4.00791L15.3498 6.652l-1.2525-1.26441Zm3.1014-3.38765H2.80118C1.81113 1.99994 1 2.81108 1 3.80113V16.3975c0 .99.81113 1.8011 1.80118 1.8011H17.1987c.99 0 1.8012-.8111 1.8012-1.8011V3.80113c.0119-.99005-.8112-1.80119-1.8012-1.80119Zm0 12.62016h-5.4035c0 .9901-.8112 1.8012-1.80123 1.8012-.99005 0-1.80118-.8111-1.80118-1.8012H2.80118V3.80113H17.1987V14.6201Z" }) });
export {
  p as Pass
};
//# sourceMappingURL=Pass.js.map
